import { AppModalType } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/AppDownload";
import { useAppDownloadState } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/AppDownloadState";
import { ViewAppLink } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/ViewAppLink";
import { LazyPhoneInput } from "@faire/retailer-visitor-shared/components/PhoneInput/LazyPhoneInput";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { Button } from "@faire/web--source/slate/Button";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { Suspense } from "react";

interface IProps {
  eventPrefix?: string;
  appModalType?: AppModalType;
  onClose: () => void;
  loggedOut?: boolean;
}

export const TextAppSection: React.FC<IProps> = ({
  eventPrefix,
  appModalType,
  onClose,
  loggedOut,
}) => {
  const { strictLocalize } = useStrictLocalization();
  const { isInvalidPhoneNumber, setPhoneNumber, phoneNumber, sendAppLink } =
    useAppDownloadState(onClose, loggedOut);

  return (
    <>
      <Typography
        variant="paragraphSansRegular"
        align={loggedOut ? "left" : "center"}
      >
        <StrictLocalMsg defaultMessage="Enter your phone number below and we’ll text you a link to download the app." />
      </Typography>
      <Spacer height="3x" />
      <div style={{ alignSelf: "stretch" }}>
        <Suspense fallback={null}>
          <LazyPhoneInput
            label={strictLocalize({
              defaultMessage: "Phone Number",
              description: {
                text: "Label to a mobile phone number input",
                img: "https://cdn.faire.com/fastly/208b5457bbff7ce3336fe0eec92df588ea19b8fd7ae654d575dd92be24391d3e.png",
              },
            })}
            helper={strictLocalize({
              defaultMessage: "Standard messaging rates apply",
              description: { text: "Warning when sending sms to an user" },
            })}
            error={
              isInvalidPhoneNumber
                ? strictLocalize({
                    defaultMessage: "Please enter a valid phone number",
                  })
                : undefined
            }
            onChangePhoneNumber={setPhoneNumber}
            defaultPhoneNumber={phoneNumber}
          />
        </Suspense>
      </div>
      <Spacer height="3x" />
      <Button onClick={() => sendAppLink(`${eventPrefix}/app-modal`)}>
        <StrictLocalMsg
          defaultMessage="Send Download Link"
          description={{
            text: "Button to send an SMS to user mobile with our app download link",
          }}
        />
      </Button>
      <Spacer height="2x" />
      {appModalType ? (
        <ViewAppLink appModalType={appModalType} eventPrefix={eventPrefix} />
      ) : null}
    </>
  );
};
